// Shared network configuration. Production defaults follow the current host.
export const API_URL = process.env.REACT_APP_API_URL || '/api';
export const WS_URL = process.env.REACT_APP_WS_URL || window.location.origin;

// Uploads are served from the API host root, not underneath /api.
export const resolveAssetUrl = (path: string): string =>
  new URL(path, new URL(API_URL, window.location.origin).origin + '/').href;
